<template>
  <div class="assign-office-form bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
    <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
      <div class="ml-4 mt-4">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Assign to an Office
        </h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">
          All of the {{ modelPrettified }}s that have been selected will be assigned to the office of your choice.
        </p>
      </div>
    </div>
    <div class="modal-body">
      <multiselect v-if="officesLoaded"
        v-model="selectedOffice"
        :options="offices"
        label="name"
        track-by="id"
        placeholder="Select office"
        :show-labels="false"
        :multiple="false"
      />
      <div class="action-buttons">
        <button type="button" class="btn btn-danger" @click="cancel">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submit" :disabled="!selectedOffice">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { startCase } from 'lodash-es'
  import Multiselect from 'vue-multiselect'
  import BulkActionService from '@services/BulkActionService'
  import FlashMessages from '@services/FlashMessages'

  export default {
    name: 'assign-office-form',
    components: {
      Multiselect,
    },
    data () {
      return {
        offices: [],
        officesLoaded: false,
        selectedOffice: null,
        processing: false,
      }
    },
    computed: {
      modelPrettified () {
        return startCase(this.model)
      },
    },
    methods: {
      requestOffices () {
        axios.get('/offices.json')
          .then(offices => {
            this.offices = [ ...offices.data]
            this.officesLoaded = true
          })
      },
      cancel () {
        this.$emit('cancel')
      },
      close () {
        this.$emit('close')
      },
      submit () {
        if (!this.processing){
          this.processing = true
          BulkActionService.assignOffice(this.ids, this.model, this.selectedOffice.id)
            .then(resp => {
              FlashMessages.success(`${resp.data.result} record(s) assigned to the ${this.selectedOffice.name} office.`, 'Success')
              this.close()
            })
            .catch(resp => {
              FlashMessages.error(`Failed to assign to office. Please try again later.`, 'Error')
              this.close()
            })
            .then(resp => this.close())
        }
      },
    },
    created () {
      this.requestOffices()
    },
    props: {
      ids: {
        type: Array,
        required: true,
      },
      model: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss">
  .assign-office-form {
    .modal-body {
      margin-top: 15px;

      .action-buttons {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
</style>
